// Environment configuration for API URLs
const getApiUrl = () => {
  // Check if we're in production (deployed on server)
  if (window.location.hostname === 'card.stardigitalsuraksha.com') {
    return '/api'; // Use relative path for production (nginx proxy)
  }
  
  // Check if we're in development (localhost)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3001/api';
  }
  
  // Fallback for other environments
  return process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api';
};

const config = {
  API_BASE_URL: getApiUrl(),
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  IS_PRODUCTION: window.location.hostname === 'card.stardigitalsuraksha.com',
  IS_DEVELOPMENT: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
};

console.log('🌍 Environment Config:', {
  API_BASE_URL: config.API_BASE_URL,
  ENVIRONMENT: config.ENVIRONMENT,
  IS_PRODUCTION: config.IS_PRODUCTION,
  IS_DEVELOPMENT: config.IS_DEVELOPMENT,
  HOSTNAME: window.location.hostname
});

export default config;